// extracted by mini-css-extract-plugin
module.exports = {"input":"PopdOrderNote_input__tGGb5"};